import React from "react";
import { ContactConfig } from "../config/commonConfig";
const AboutUs = (props) => {
  const { content } = props;

  return (
    <section id="about" className="section">
      <div className="container">
        {/* Heading */}
        <p className="text-center mb-2 wow fadeInUp">
          <span className="bg-primary text-dark px-2">About Me</span>
        </p>
        <h2 className="text-10 fw-600 text-center mb-5 wow fadeInUp">
          Know Me More
        </h2>
        {/* Heading end*/}
        <div className="row">
          <div className="col-lg-8 text-center text-lg-start wow fadeInUp">
            <h2 className="text-8 fw-400 mb-3">
              Hi, I'm{" "}
              <span className="fw-700 border-bottom border-3 border-primary">
                {content.first_name} {content.last_name}
              </span>
            </h2>
            <p className="text-5">
              {content.about_me_part_1}
              <br />
              <br />
              {content.about_me_part_2}
              {/*<br/><br/>*/}
              {/*Don't hesitate any longer – join me on this transformative journey to make your dreams a reality and experience the difference that my expertise can bring to your life!*/}
            </p>
          </div>
          <div
            className="col-lg-4 mt-4 mt-lg-0 wow fadeInUp"
            data-wow-delay="0.2s"
          >
            <div className="featured-box style-4">
              <div className="featured-box-icon text-25 fw-500 bg-primary rounded-circle">
                <span className="wow heartBeat" data-wow-delay="1.3s">
                  {/* 1 */}
                </span>
              </div>
              <h3 className="text-7 wow rubberBand" data-wow-delay="2s">
                Best AI Coach
              </h3>
            </div>
          </div>
        </div>
        <div className="row gy-3 mt-4">
          <div className="col-6 col-lg-3 wow fadeInUp" data-wow-delay="0.2s">
            <p className="text-muted fw-500 mb-0">Specialty:</p>
            <p className="text-4 fw-600 mb-0">
              <p className="text-4 text-dark fw-600 mb-0">
                {content.specialty}
              </p>
            </p>
          </div>
          <div className="col-6 col-lg-3 wow fadeInUp" data-wow-delay="0.3s">
            <p className="text-muted fw-500 mb-0">Methodology:</p>
            <p className="text-4 text-dark fw-600 mb-0">
              {content.methodology}
            </p>
          </div>
          <div className="col-6 col-lg-3 wow fadeInUp">
            <p className="text-muted fw-500 mb-0">Philosophy:</p>
            <p className="text-4 text-dark fw-600 mb-0">{content.philosophy}</p>
          </div>
          <div className="col-6 col-lg-3 wow fadeInUp" data-wow-delay="0.4s">
            <p className="text-muted fw-500 mb-0">AI technology:</p>
            <p className="text-4 text-dark fw-600 mb-0">Chat GPT & Sista LLM</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
